function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import clone from 'clone-deep';
export function stripUndefined(obj) {
  if (obj === undefined || obj === null) {
    return obj;
  }

  var objClone = clone(obj);

  if (Array.isArray(objClone)) {
    return objClone.map(stripUndefined);
  } else if (_typeof(objClone) === 'object' && Object.keys(objClone).length > 0) {
    var keys = Object.keys(objClone);

    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      var key = _keys[_i];
      var value = objClone[key];

      if (value === undefined) {
        delete objClone[key];
      } else {
        objClone[key] = stripUndefined(objClone[key]);
      }
    }
  }

  return objClone;
}